import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'
import { MenuItem, Select } from '@mui/material'
import PropTypes from 'prop-types'

import { selectWebStoreFoldingEnabled } from '@/app/slices/organisationSlice'

const LayerType = ({ handleUpdateLayerType, isDisabled, layerType }) => {
    const { t } = useTranslation()
    const foldingEnabled = useSelector(selectWebStoreFoldingEnabled)

    const [itemLayerType, setItemLayerType] = useState(layerType)

    const handleTypeChange = async (event) => {
        const value = event?.target?.value
        setItemLayerType(value)
        handleUpdateLayerType(value)
    }

    return (
        <Select
            data-testid="order-item-consumption-mode"
            disabled={isDisabled}
            id="select-itemConsumptionMode"
            inputProps={{
                'data-testid': 'drawingdoctordrawer-layer-layertype-input',
                sx: { padding: 1 },
            }}
            labelId="select-itemConsumptionMode-label"
            sx={{
                '& .MuiSelect-select': { fontSize: '14px', paddingBlock: '5px', paddingInline: '12px' },
            }}
            value={itemLayerType}
            fullWidth
            onChange={handleTypeChange}
        >
            <MenuItem value="Cutting">{t('Cutting')}</MenuItem>
            <MenuItem value="Etching">{t('Etching')}</MenuItem>
            <MenuItem value="Information">{t('Information')}</MenuItem>
            {foldingEnabled ? <MenuItem value="Folding">{t('Folding')}</MenuItem> : null}
        </Select>
    )
}

LayerType.propTypes = {
    handleUpdateLayerType: PropTypes.func,
    isDisabled: PropTypes.bool,
    layerType: PropTypes.string,
}

export default LayerType
